
import { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TopAgency from './components/TopAgency';
import AgencyList from './components/AgencyList';
import WhyChooseUs from './components/WhyChooseUs';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function Home() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Navbar isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      <Hero />
      <TopAgency />
      <AgencyList />
      <WhyChooseUs />
      <CTA />
      <Footer />
    </div>
  );
}
